import { Injectable } from '@angular/core';
import { Connection } from '@3d-scene/model3d/connection';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { PropertyValueVO, PropertyVO } from '../components/article/model/vo/property.vo';
import { ProjectVO } from '../model/vo/project.vo';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { MetaElementUsageUtils } from '../util/meta-element-usage-utils';

interface LtlInfo {
  No: string;
  itemsData: LtlInfoArticle[];
}

interface LtlInfoArticle {
  ArticleNumber: string;
  PE_contact: number;
  Locking_pin: number;
}

@Injectable({
  providedIn: 'root'
})
export class JsonInfoService {

  constructor(
    private containerService: ContainerService,
    private articleContainerUtils: ArticleContainerUtils,

  ) {}

  public createProjectInfoJson(project: ProjectVO): string {
    const firstContainer = this.containerService.getFirstArticleContainerInGlobal();
    const ltlArticles: ArticleContainer[] = this.articleContainerUtils.getConnectedArticles(firstContainer);
    const ltlInfo: LtlInfo = {No: project.articleNumberLong.extendedArticleNumberLong, itemsData: []};
    ltlArticles.forEach((ltlArticle: ArticleContainer) => {
      const articleInfo: LtlInfoArticle = {ArticleNumber: ltlArticle.article.articleNo, PE_contact: 0, Locking_pin: 0};
      const peContactConnections = ltlArticle.connections.filter(
        (connection: Connection) => this.connectionHasMetaElementType(connection, 'PE-Kontakt')
      );
      peContactConnections.sort((a, b) => b.meshPosition.y - a.meshPosition.y);
      let multiplicity = 0;
      articleInfo.PE_contact = Math.max(...(peContactConnections.map((connection, index) => {
        if (connection.metaElementVO instanceof ConnectionAreaVO) {
          multiplicity = connection.metaElementVO.connectionMultiplicity;
        }
        return !MetaElementUsageUtils.isFreeConnectionUsage(connection.metaElementUsage, multiplicity) ? index + 1 : 0
      })));

      const pinConnections = ltlArticle.connections.filter(
        (connection: Connection) => this.connectionHasMetaElementType(connection, 'PIN')
      );
      pinConnections.sort((a, b) => b.meshPosition.z - a.meshPosition.z);
      multiplicity = 0;
      if (pinConnections[1].metaElementVO instanceof ConnectionAreaVO) {
        multiplicity = pinConnections[1].metaElementVO.connectionMultiplicity;
      }
      articleInfo.Locking_pin = !MetaElementUsageUtils.isFreeConnectionUsage(pinConnections[1].metaElementUsage, multiplicity) ? 1 : 0;
      ltlInfo.itemsData.push(articleInfo)
    });
    return JSON.stringify(ltlInfo, null, 2);
  }

  private connectionHasMetaElementType(connection: Connection, type: string): boolean {
    if ('connectionRequirements' in connection.metaElementVO) {
      const connectionArea = connection.metaElementVO as ConnectionAreaVO;
      return connectionArea.connectionRequirements.some((connectionArea: PropertyVO) => {
        return connectionArea.values.some((value: PropertyValueVO) => {
          return value.stringValue === type
        });
      });
    }
    return false;
  }
}
